import MapsService from '@/services/maps/maps.service';
import PopupService from '@/services/maps/popups/popup.service';
import store from '@/store/index';
import { Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';

@Module({ dynamic: true, store, name: 'maps' })
class Maps extends VuexModule {

    mapService = new MapsService()
    popupService = new PopupService()

    @Mutation
    initMapService() {
        this.mapService.init()
    }

    @Mutation
    initPopupService() {
        this.popupService.init()
    }

    @Mutation
    updatePrincipalMap() {
        this.mapService.map.updateSize();
    }

}
export default getModule(Maps);